import { TransformationBuilderContent } from './transformation-builder-content';

export function TransformationBuilderPage() {
  return <TransformationBuilderContent />;
}
